module.exports = __webpack_public_path__ + "img/专利证书08_基于能源系统能效评价的智慧管理平台v1.0.79c79ec4.png";